
import { Component, ComponentRef, NgModule, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { Subject } from 'rxjs';
import { Client } from '../auth/auth.model';
import { AuthService } from '../shared/auth/auth.service';
import { IModalDialog, IModalDialogOptions } from '../shared/services/modal.interface';
import { UtilsService } from '../shared/services/utils.service';
import { Product } from './offer.model';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'offer-create-dialog',
  templateUrl: 'offer-create.dialog.component.html',
  styleUrls: ['offer-create.dialog.component.scss'],
  providers: [ FormBuilder ]
})
export class OfferCreateDialogComponent implements IModalDialog{

  public form: FormGroup;
  public dialogSubject: Subject<void>;
  public product: Product;
  public product_copy: Product;
  public product_related: Product[];
  public product_related_copy: Product[];
  public cdn = environment.cdn;

  public modified_percent = 0;
  public showGrossControls = true;

  constructor(public fb: FormBuilder, public auth: AuthService, private utilsService: UtilsService) {}

  dialogInit(ref: ComponentRef<IModalDialog>, options: Partial<IModalDialogOptions<any>>) {
    this.dialogSubject = options.closeDialogSubject;
    this.product = options?.data?.product || null;
    if (+this.product.tax > 0) {
      this.showGrossControls = true;
    } else{
      this.showGrossControls = false;
    }
    this.product_copy = {...this.product};
    this.product_related = options?.data?.related || [];
    this.product_related_copy = this.product_related.map(a => {return {...a}});
    this.createForm();
  }


  createForm() {
    this.form = this.fb.group({
      expiration_date: [''],
      modified_percent: [''],
      modified_percent_gross: [''],
      modified_price: [''],
      modified_price_gross: [''],
      tax: [this.product.tax],
      tax_type: [false],
      comment: [''],
      related: this.fb.array([]),
      comment_sec: [''],
    });
    
    

    const relatedFormArray = this.form.get('related') as FormArray;
    let i = 0;
    this.product_related.forEach(r => {
      const rform = this.fb.group({
        id: [r.variant_id],
        index: [i],
        modified_percent: [{value: '', disabled: true}],
        modified_price: [{value: '', disabled: true}],
        selected: [false]
      });

      rform.get('selected').valueChanges.subscribe((val: string) => {
        if (val) {
          rform.get('modified_percent').enable({emitEvent: false});
          rform.get('modified_price').enable({emitEvent: false});
        } else {
          rform.get('modified_percent').disable({emitEvent: false});
          rform.get('modified_price').disable({emitEvent: false});
        }
      });
      rform.get('modified_percent').valueChanges.subscribe((val: string) => {
        let j = +rform.get('index').value;
        if (val) {
          let p = val.replace(',', '.').replace(/[^\d.-]/g, '');
          let add = +this.product_related_copy[j].price * (+p / 100);
          this.product_related[j].price = +this.product_related_copy[j].price + add; 
          rform.get('modified_price').setValue('', { emitEvent: false });
        } else {
          this.product_related[j].price = +this.product_related_copy[j].price;
        }
      });
      rform.get('modified_price').valueChanges.subscribe((val: string) => {
        let j = +rform.get('index').value;
        if (val) {
          let p = val.replace(',', '.').replace(/[^\d.-]/g, '');
          this.product_related[j].price = +p;
          rform.get('modified_percent').setValue('', { emitEvent: false });
        } else {
          this.product_related[j].price = +this.product_related_copy[j].price;
        }
      });


      relatedFormArray.push(rform);
      i++;
    })

    this.form.get('modified_percent').valueChanges.subscribe((val: string) => {
      if (val) {
        let p = val.replace(',', '.').replace(/[^\d.-]/g, '');
        let add = this.product_copy.price * (+p / 100);
        this.product.price = +this.product_copy.price + add; 
        this.form.get('modified_price').setValue('', { emitEvent: false });
        this.form.get('modified_price_gross').setValue('', { emitEvent: false });
        this.form.get('modified_percent_gross').setValue('', { emitEvent: false });
      } else {
        this.product.price = this.product_copy.price;
      }
      // this.form.get('tax_type').setValue(false);
    });
    this.form.get('modified_percent_gross').valueChanges.subscribe((val: string) => {
      if (val) {
        let p_grss = +this.product_copy.price;
        if (this.form.get('tax').value) {
          p_grss = +this.product_copy.price + (+this.product_copy.price * +this.form.get('tax').value / 100);
        } else {
          p_grss = +this.product_copy.price + (+this.product_copy.price * +this.product_copy.tax / 100);
        }
        let p = val.replace(',', '.').replace(/[^\d.-]/g, '');
        p_grss = p_grss + p_grss * (+p / 100);

        let p_nett = +this.product_copy.price;
        if (this.form.get('tax').value) {
          p_nett = +p_grss / (1 + +this.form.get('tax').value / 100);
        } else {
          p_nett = +p_grss / (1 + +this.product_copy.tax / 100);
        }
        
        this.product.price = p_nett;
        this.form.get('modified_price').setValue('', { emitEvent: false });
        this.form.get('modified_price_gross').setValue('', { emitEvent: false });
        this.form.get('modified_percent').setValue('', { emitEvent: false });
      } else {
        this.product.price = this.product_copy.price;
      }
      // this.form.get('tax_type').setValue(true);
    });


    this.form.get('modified_price').valueChanges.subscribe((val: string) => {
      if (val) {
        let p = val.replace(',', '.').replace(/[^\d.-]/g, '');
        let p_grss = +p;
        if (this.form.get('tax').value) {
          p_grss = +p + (+p * +this.form.get('tax').value / 100);
        } else {
          p_grss = +p + (+p * +this.product_copy.tax / 100);
        }
        this.form.get('modified_price_gross').setValue('', { emitEvent: false });
        this.product.price = +p;
        this.form.get('modified_percent').setValue('', { emitEvent: false });
        this.form.get('modified_percent_gross').setValue('', { emitEvent: false });
      } else {
        this.product.price = this.product_copy.price;
      }
      // this.form.get('tax_type').setValue(false);
    });
    this.form.get('modified_price_gross').valueChanges.subscribe((val: string) => {
      if (val) {
        let p = val.replace(',', '.').replace(/[^\d.-]/g, '');
        let p_nett = +p;
        if (this.form.get('tax').value) {
          p_nett = +p / (1 + +this.form.get('tax').value / 100);
        } else {
          p_nett = +p / (1 + +this.product_copy.tax / 100);
        }
        p_nett = Math.round((p_nett + Number.EPSILON) * 100) / 100;
        this.form.get('modified_price').setValue('', { emitEvent: false });
        this.product.price = +p_nett;
        this.form.get('modified_percent').setValue('', { emitEvent: false });
        this.form.get('modified_percent_gross').setValue('', { emitEvent: false });
      } else {
        this.product.price = this.product_copy.price;
      }
      // this.form.get('tax_type').setValue(true);
    });

    this.form.get('tax').valueChanges.subscribe((val: string) => {
      if (val) {
        this.product.tax = +val;
        if (+val > 0) {
          this.showGrossControls = true;
        } else {
          this.showGrossControls = false;
        }
      }
    });
  }

  get formRelated() { return <FormArray>this.form.get('related'); }

  submit() {
    const formModel = this.form.value;
    formModel.action = 'generate';
    this.dialogSubject.next(formModel)
  }

  close() {
    const formModel = this.form.value;
    formModel.action = 'cancel';
    this.dialogSubject.next(formModel);
  }
  

}